import { useMemo } from 'react';

import Skeleton from 'src/components/atoms/Skeleton';

import FormGrid from '../FormGrid';

export type SkeletonEntryFormProps = { fields?: number };

/*
 * A general purpose skeleton entry form.
 * @param {number} columns - The number of columns to display.
 * @param {number} rows - The number of rows to display.
 */
export default function SkeletonEntryForm({ fields }: SkeletonEntryFormProps) {
  const form = useMemo(() => {
    const form = [];
    for (let i = 0; i < fields; i++) {
      form.push(
        <div key={i} className="flex flex-col gap-1">
          {/* Space for label */}
          <div className="h-5" />
          {/* Input skeleton */}
          <Skeleton variant="rounded" height={40} />
        </div>
      );
    }
    return form;
  }, [fields]);

  return <FormGrid>{form}</FormGrid>;
}
